import { render, staticRenderFns } from "./MoveInAgeCard.vue?vue&type=template&id=3efe0ccf&scoped=true&"
import script from "./MoveInAgeCard.vue?vue&type=script&lang=js&"
export * from "./MoveInAgeCard.vue?vue&type=script&lang=js&"
import style0 from "./MoveInAgeCard.vue?vue&type=style&index=0&id=3efe0ccf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efe0ccf",
  null
  
)

export default component.exports